import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import api from "../api/httpClient";
import { API_PATHS } from "../api/apiPaths";

const extractSlides = (response) => {
  const value = response?.data?.data ?? response?.data ?? [];
  const items = Array.isArray(value) ? value : value.items || value.slides || value.content || [];
  return items.filter((item) => item?.imageUrl).map((item, index) => ({
    id: item.id || item.slideId || index,
    imageUrl: item.imageUrl,
    title: item.title || "",
    caption: item.caption || item.description || "",
  }));
};

export default function SchoolHomeSlider() {
  const [slides, setSlides] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    let mounted = true;
    api.get(API_PATHS.branding.homeSlides())
      .then((response) => { if (mounted) setSlides(extractSlides(response)); })
      .catch(() => { if (mounted) setSlides([]); });
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (slides.length < 2) return undefined;
    const timer = window.setInterval(() => setActive((current) => (current + 1) % slides.length), 5500);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  useEffect(() => { if (active >= slides.length) setActive(0); }, [active, slides.length]);
  if (!slides.length) return null;
  const slide = slides[active];
  const move = (amount) => setActive((current) => (current + amount + slides.length) % slides.length);

  return <section className="mx-auto mb-6 w-full max-w-[1500px] px-4 sm:px-6 lg:px-8" aria-label="School highlights" aria-roledescription="carousel">
    <div className="group relative aspect-[16/5] min-h-[210px] overflow-hidden rounded-3xl bg-slate-900 shadow-xl">
      <img key={slide.id} src={slide.imageUrl} alt={slide.title || "School highlight"} className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-slate-950/25 to-transparent" />
      {(slide.title || slide.caption) && <div className="absolute inset-x-0 bottom-0 max-w-2xl p-6 text-white sm:p-9"><h2 className="text-2xl font-black sm:text-4xl">{slide.title}</h2>{slide.caption && <p className="mt-2 line-clamp-2 text-sm text-slate-100 sm:text-base">{slide.caption}</p>}</div>}
      {slides.length > 1 && <><button type="button" onClick={() => move(-1)} aria-label="Previous school highlight" className="absolute left-3 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-slate-950/55 text-white opacity-80 backdrop-blur hover:opacity-100"><FaChevronLeft /></button><button type="button" onClick={() => move(1)} aria-label="Next school highlight" className="absolute right-3 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-slate-950/55 text-white opacity-80 backdrop-blur hover:opacity-100"><FaChevronRight /></button><div className="absolute bottom-3 right-4 flex gap-1.5">{slides.map((item, index) => <button key={item.id} type="button" aria-label={`Show school highlight ${index + 1}`} onClick={() => setActive(index)} className={`h-1.5 rounded-full transition-all ${index === active ? "w-8 bg-white" : "w-4 bg-white/50"}`} />)}</div></>}
    </div>
  </section>;
}
